import React, { useLayoutEffect, useRef, useState } from 'react';
import WindowGrid from './windowgrid'; // Assuming WindowGrid is defined in a separate module
import {drawLines} from './drawlines';
import {makeInclosureImage} from './makeinclosureimage';
import { paintSVG } from './paintsvg';
import { toDecimal } from './controls/conversions';
import { formatToFractional } from './controls/conversions';
import { formatToDecimal } from './controls/conversions';
import ImageProcessing from "./ImageProcessing";


export function adjustParameters(frameW, frameH, frameSide, frameType) {
  const k = 5;
  const outerFrameWidth = 8;
  const spacing = 1;
  const fillet = 1;
  const innerMargin = 16;

  let doorType = 0;
  let rows = 1, columns = 3;
  let w1 = 0, w2 = 0, w3 = 0, w4 = 0;
  let result = true;

  const configMap = {
    1: { doorType: 1, columns: 3, w: [0, k * frameW, 0, 0], frameSide: 0 },
    2: { doorType: 1, columns: 3, w: [k * frameSide, k * frameW, 0, 0] },
    3: { doorType: 1, columns: 3, w: [0, k * frameW, k * frameSide, 0] },
    4: { doorType: 1, columns: 3, w: [k * frameSide, k * frameW, k * frameSide, 0] },
    5: { doorType: 2, columns: 4, w: [0, k * frameW / 2, k * frameW / 2, 0], frameSide: 0 },
    6: { doorType: 2, columns: 4, w: [k * frameSide, k * frameW / 2, k * frameW / 2, 0] },
    7: { doorType: 2, columns: 4, w: [0, k * frameW / 2, k * frameW / 2, k * frameSide] },
    8: { doorType: 2, columns: 4, w: [k * frameSide, k * frameW / 2, k * frameW / 2, k * frameSide] }
  };

  const config = configMap[frameType];

  if (!config) {
    return { doorType: 0, result: false };
  }

  doorType = config.doorType;
  columns = config.columns;
  [w1, w2, w3, w4] = config.w;
  if (config.frameSide === 0) frameSide = 0;

  // Calculate width and height
  const frameSideCount = (frameType === 4 || frameType === 8) ? 2 : (frameType === 2 || frameType === 3 || frameType === 6 || frameType === 7) ? 1 : 0;
  const width = k * (frameW + frameSideCount * frameSide + 3 * spacing);
  const height = k * frameH;

  // Dimensions with padding
  const width1 = width + 15;
  const height1 = height + 60;

  // Labels
  const labelWidth = (frameW + frameSideCount * frameSide).toString() + '"';
  const labelHeight = frameH.toString() + '"';

  // Bracket sizes
  const bottomBracketSize = width - k * outerFrameWidth - innerMargin + 15;
  const rightBracketSize = height;

  return {
    doorType,
    result,
    width,
    height,
    rows,
    columns,
    spacing,
    fillet,
    outerFrame: false,
    outerFrameWidth,
    w1,
    w2,
    w3,
    w4,
    innerMargin,
    width1,
    height1,
    labelHeader: "View From Outside",
    labelWidth,
    labelHeight,
    bottomBracketSize,
    rightBracketSize
  };
}
  

function validateDoor(selectedDoor, frameWidth, frameHeight) {
  const validSingleDoubleDoorIds = [1, 2, 3, 4, 5, 6, 7, 8];
  const isWidthValid = frameWidth >= 24 && frameWidth <= 80;
  const isHeightValid = frameHeight >= 34 && frameHeight <= 96;

  if (!selectedDoor || !validSingleDoubleDoorIds.includes(selectedDoor.id)) {
    return false;
  }

  return isWidthValid && isHeightValid;
}

 
  const Drawing = ({  doorData = null, selectedDoor, frameData, frameWidth, frameHeight, doorSize, doorHeight, sideLiteSize, 
                      hinges, transom, swing, doorLite, selectedPanel, selectedDoorLite  }) => {
    const [parameters, setParameters] = useState(null);
    const svgRef = useRef(null);
    //alert(JSON.stringify(transom, null, 2));
    //console.log(selectedDoor + '-' + frameWidth+ '-' +frameHeight+ '-' +sideLiteSize+ '-' +hinges+ '-' +transom+ '-' +swing);
  useLayoutEffect(() => {
  
    /* 40-80, 34-96, 2-15 */ /* 24-40, 34-96, 2-15 */
    /*
    if (frameHeight == ""){return;}
    if (sideLiteSize == ""){sideLiteSize = "0";}

    if (transom?.overallHeight?.value === undefined) {
      return;
    }
    if (parseInt(transom.overallHeight.value,10) < parseInt(frameHeight, 10)) {
      return;
    }
    */
    if (transom?.overallHeight?.value) {
      // Value exists and is truthy — do nothing or run your logic
    } else {
        if (transom && transom.overallHeight) {
          transom.overallHeight.value = 0;
        }
    }


    if (transom.overallHeight.value + "" == "") {
      transom.overallHeight.value = 0;
    }
    if ((transom.transom.value === 'Rectangle') && (transom.overallHeight.value < parseInt(frameHeight, 10))){
      transom.overallHeight.value = 0;
    }
    if ((transom.transom.value === 'Ellipse') && (transom.overallHeight.value < parseInt(frameHeight, 10))){
      return;
    }
    if (transom.overallHeight.value <=1) {
      transom.overallHeight.value = 0;
    }
    
    if (transom.transom.value === 'Rectangle' || transom.transom.value === 'Ellipse') {
      let overallHeight1 = parseInt(transom.overallHeight.value,10) - parseInt(frameHeight, 10);
      frameHeight = transom.overallHeight.value;
      transom.overallHeight.value = overallHeight1;
    }
    else{
      transom.overallHeight.value = 0;
    }
    if (!hinges) {hinges = 'Left';}
    if (!swing) {swing = 'Inswing';}
    
    if (selectedDoor.id && ((typeof frameData !== "undefined"))){
      if (frameData.doorSize)    frameData.doorSize    = toDecimal(frameData.doorSize);
      if (frameData.doorHeight)  frameData.doorHeight  = toDecimal(frameData.doorHeight);
      if (frameData.frameWidth)  frameData.frameWidth  = toDecimal(frameData.frameWidth);
      if (frameData.frameHeight) frameData.frameHeight = toDecimal(frameData.frameHeight);
      if (frameData.frameWidth){
        if ([1].includes(selectedDoor.id)) {
         sideLiteSize = 0;
         frameWidth = frameData.frameWidth;
         }
         if ([2,3].includes(selectedDoor.id)) {
          sideLiteSize = frameData.frameWidth - frameData.doorSize;
          frameWidth = frameData.doorSize;
         }
         if ([4].includes(selectedDoor.id)) {
          sideLiteSize =( frameData.frameWidth - frameData.doorSize) /2;
          frameWidth = frameData.doorSize;
         }
         if ([5].includes(selectedDoor.id)) {
          sideLiteSize = 0;
          frameWidth = frameData.frameWidth;
         }
         if ([6, 7].includes(selectedDoor.id)) {
          frameWidth = frameData.doorSize*2 - 2;
          sideLiteSize = frameData.frameWidth - frameWidth;
         }
         if ([8].includes(selectedDoor.id) ){
          sideLiteSize = (frameData.frameWidth - frameData.doorSize*2)/2;
          frameWidth = frameData.doorSize*2;
         }
         frameHeight = frameData.frameHeight;
      }  
    }


    if (typeof frameWidth === "string") {
      frameWidth = parseInt(frameWidth, 10);
    }
    if (typeof frameHeight === "string") {
      frameHeight = parseInt(frameHeight, 10);
    }
    if (typeof sideLiteSize === "string") {
      sideLiteSize = parseInt(sideLiteSize, 10);
    }
    
    if (doorData && 0){
      frameWidth = doorData.frameData.frameWidthRound;
      //frameHeight = doorData.frameData.frameHeightRound;
      sideLiteSize = doorData.frameData.sideLiteSizeRound;
      selectedDoor.name = doorData.frameData.selectedDoor.name;
      transom.overallHeight.value = 0;
      if (parseFloat(doorData.transomData.OverallHeight) > parseFloat(doorData.frameData.frameHeight)){
        transom.overallHeight.value = String(Math.round(parseFloat(doorData.transomData.OverallHeight) 
                                           - parseFloat(doorData.frameData.frameHeight)) || 0); 
        //doorData.frameData.frameHeight = parseInt(doorData.transomData.OverallHeight);
      }
    }

    let parameters = null;
    if ((isNaN(frameWidth))  || (frameWidth  < 10)) {return;} //prevent one number numbering
    if ((isNaN(frameHeight)) || (frameHeight < 10)) {return;} //prevent one number numbering
    parameters = adjustParameters(frameWidth, 
                                  frameHeight, 
                                  sideLiteSize, 
                                  selectedDoor.id);
                                      
    if (doorData && 1){
      if ([1, 5].includes(selectedDoor.id)){ 
        parameters.labelWidth = doorData.frameData.frameWidthLabel;
      }
      else { 
        let a = formatToDecimal(doorData.frameData.frameWidth);
        let b = formatToDecimal(doorData.frameData.sideLiteSize);
        a = isNaN(parseFloat(a)) ? 0 : parseFloat(a);
        b = isNaN(parseFloat(b)) ? 0 : parseFloat(b);
        if ([4, 8].includes(selectedDoor.id)){
          b = b * 2;
        }
        parameters.labelWidth = formatToFractional(a + b);
      }
      parameters.labelHeight = doorData.frameData.frameHeightLabel;
      if (parseFloat(doorData.transomData.OverallHeight) > parseFloat(doorData.frameData.frameHeight)){
        parameters.labelHeight = formatToFractional(doorData.transomData.OverallHeight);
      }
    }
    else{
      parameters.labelWidth = formatToFractional(parameters.labelWidth);
      parameters.labelHeight = formatToFractional(parameters.labelHeight);
    }
    let windowGrid;
    if (parameters.result){
        windowGrid = new WindowGrid(
        parameters.doorType,
        parameters.width, 
        parameters.height,
        parameters.rows,
        parameters.columns,
        parameters.spacing,
        parameters.fillet,
        true, //parameters.outerFrame,
        2,    //parameters.outerFrameWidth,
        parameters.w1,
        parameters.w2,
        parameters.w3,
        parameters.w4,
        parameters.innerMargin - 4,
        5*transom.overallHeight.value
    );
  }
  else{
    return ("<div>item not found</div>");
  }

    //let svg;
    let { svg, sizes } = windowGrid;
    //alert(JSON.stringify(sizes, null, 2));
    if (parameters.result){
        //==>svg = makerjs.exporter.toSVG(windowGrid); // Export the grid to SVG
    }

    if (parameters.result & true){
      transom.overallHeight.value = 5*transom.overallHeight.value;
      svg = paintSVG(svg, parameters.columns);
      svg = drawLines(svg,
                      doorData, 
                      parameters.width, 
                      parameters.height,
                      parameters.rows,
                      parameters.columns,
                      parameters.spacing,
                      parameters.fillet,
                      true, //parameters.outerFrame,
                      2,    //parameters.outerFrameWidth,
                      parameters.w1,
                      parameters.w2,
                      parameters.w3,
                      parameters.w4,
                      parameters.innerMargin - 4,
                      transom,
                      sizes,
                      hinges,
                      swing,
                      doorLite,
                      selectedPanel,
                      selectedDoorLite,
                      frameData,
                      true, //hinges
                      !!doorData?.frameData?.tilt, //false - entry door, true  - tilt
      );
      //svg = drawRect(toSVG(svg), -95.5, 12, 176, 376, /*delta =*/ 2, 'red', /*opacity =*/ 1, /*k =*/ 1, /*gradient =*/1);
    }
  /*  "innerRect1": {
    "width": 176,
    "height": 376,
    "x": -95.5,
    "y": 12*/
    
  if (parameters.result & true){
      svg = makeInclosureImage(svg, parameters.width  , parameters.height + 100, 
                                    parameters.labelHeader, parameters.labelWidth, parameters.labelHeight, 
                                    parameters.width , parameters.height + 100);
  }
  
  if (parameters.result){  
    if (svgRef.current) { 
      svgRef.current.innerHTML = svg; //// Set the SVG content to the ref element
    }
  }
  
  }, [doorData, selectedDoor, frameData, frameWidth, frameHeight, doorSize, doorHeight, sideLiteSize, hinges, transom, swing, doorLite, 
    selectedPanel, selectedDoorLite]);
   
  return (
    <div>
      {svgRef.current ? (
        <div ref={svgRef}></div>
      ) : (
        <div ref={svgRef}></div>
      )}
    </div>
  );
  return (
    <div>
        <ImageProcessing />
    </div>
);
  };

export default Drawing;
